// import { combineReducers } from "redux";
import { createStore } from "redux";
import { SET_TOKEN } from "./action";

const initialState = { loginToken: "logInitial" };

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TOKEN:
      // console.log("State Ser" + action.logToken);
      return {
        ...state,
        loginToken: action.logToken,
      };

    default:
      return state;
  }
};

// const SignupStoreApp = combineReducers({
//   SignupStore,
// });

export default createStore(rootReducer);
